
import PropTypes from 'prop-types'
import moment from 'moment'

const formatDateValue = (value) =>
  value ? moment(value).format('DD/MM/YYYY') : '-'

const formatNotePreview = (item) => {
  return item?.latestNoteText || ''
}

export const model = [
  {
    key: 'checkbox',
    label: '',
    column: {
      visible: true,
      width: 40,
      header: ({ actions, model }) => {
        const totalRows =
          (Array.isArray(model?.data) && model.data.length) ||
          (Array.isArray(model?.list?.ids) && model.list.ids.length) ||
          0
        const selectedCount = Array.isArray(model?.selected)
          ? model.selected.length
          : 0
        const allSelected = totalRows > 0 && selectedCount === totalRows

        const handleChange = (event) => {
          if (event.target.checked) {
            actions.selectItems(model.data)
          } else {
            actions.removeItems(model.data)
          }
        }

        return (
          <input
            type="checkbox"
            checked={allSelected}
            onChange={handleChange}/>
        )
      },
    },
    prop: {
      type: PropTypes.bool,
      value: false,
    },
  },
  {
    key: 'transactionDate',
    label: 'Date',
    column: { visible: true, width: 120 },
    prop: { type: PropTypes.string, value: '' },
    render: formatDateValue,
  },
  {
    key: 'thirdPartyNumber',
    label: 'Third Party Number',
    column: { visible: true, width: 120 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'agreementNumber',
    label: 'Agreement Number',
    column: { visible: true, width: 130 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'customerName',
    label: 'Customer Name',
    column: { visible: true, width: 160 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'status',
    label: 'Status',
    column: { visible: true, width: 140 },
    prop: { type: PropTypes.string, value: 'Pending review' },
  },
  {
    key: 'vehicleRegistration',
    label: 'Vehicle Registration',
    column: { visible: true, width: 140 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'vehicleDescription',
    label: 'Vehicle Type',
    column: { visible: true, width: 200 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'manufacturerDescription',
    label: 'Vehicle Make',
    column: { visible: true, width: 130 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'driverName',
    label: 'Driver',
    column: { visible: true, width: 160 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'exception',
    label: 'Exception Type',
    column: { visible: true, width: 180 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'costCentre',
    label: 'Cost Centre',
    column: { visible: true, width: 150 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'locationName',
    label: 'Location',
    column: { visible: true, width: 220 },
    prop: { type: PropTypes.string, value: '' },
  },
  {
    key: 'fleetController',
    label: 'Fleet Controller',
    column: { visible: true, width: 160 },
    prop: { type: PropTypes.string, value: '-' },
  },
  {
    key: 'latestNoteText',
    label: 'Notes',
    column: { visible: true, width: 280 },
    prop: { type: PropTypes.string, value: '' },
    render: (value, item) => formatNotePreview(item),
  },
]

const config = {
  title: 'Fuel Card Exceptions',
  breadcrumbs: null,
  idKey: 'agreementNumber',
  api: {
    resource: '/Report/ExceptionReportFilterModel',
    filter: '/filteroptions/fuelexceptions',
    download: '/download/exceptions',
  },
  model,
  headers: model.map((entry) => entry.key),
  filters: [
    {
      key: 'exception',
      label: 'Exception Type',
      prop: { type: PropTypes.string, value: '' },
    },
    {
      key: 'costCentre',
      label: 'Cost Centre',
      prop: { type: PropTypes.string, value: '' },
    },
    {
      key: 'vehicleDescription',
      label: 'Vehicle Type',
      prop: { type: PropTypes.string, value: '' },
    },
    {
      key: 'driver',
      label: 'Driver',
      prop: { type: PropTypes.string, value: '' },
    },
    {
      key: 'status',
      label: 'Status',
      prop: { type: PropTypes.string, value: '' },
    },
    {
      key: 'fleet',
      label: 'Fleet',
      prop: { type: PropTypes.string, value: '' },
    },
    {
      key: 'fleetController',
      label: 'Fleet Controller',
      prop: { type: PropTypes.string, value: '' },
    },
  ],
}

export default config
